"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18N = void 0;
const validation_1 = require("../../validation");
const locale_1 = require("./locale");
/** @alpha */
var I18N;
(function (I18N) {
    I18N.schema = {
        type: 'object',
        properties: {
            code: locale_1.Locale.schema,
            text: {
                type: 'string'
            }
        },
        additionalProperties: true,
        required: ['code', 'text']
    };
    I18N.validate = (0, validation_1.generateLazyValidator)(I18N.schema);
})(I18N = exports.I18N || (exports.I18N = {}));
//# sourceMappingURL=i18n.js.map